import { ApiRequest } from "GlobalFunctions";
import { useEffect, useState } from "react";
import { PiCaretDown } from "react-icons/pi";

export default function EventLogs(props: any) {

    const {
        url,
        queryParams = {},
        emptyMessage = "Your logs will appear here as they occur."
    } = props;

    const [logs, setLogs] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState({ total_items: 0, total_pages: 0 });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getLogs();
    }, [])
    
    /*=========================================================
    GET LOGS
    =========================================================*/
    const getLogs = (page = 1, append = false) => {
        setLoading(true);
        ApiRequest({
            method: "GET",
            url: url,
            query: { ...queryParams, page },
            setResponse: (response: any) => {
                if (append) {
                    setLogs(prev => [...prev, ...response.list]);
                } else {
                    setLogs(response.list);
                }
                setPagination(response.pagination);
                setCurrentPage(page);
                setLoading(false);
            },
        });
    }

    /*=========================================================
    LOAD MORE LOGS
    =========================================================*/
    const loadMoreLogs = () => {
        const nextPage = currentPage + 1;
        getLogs(nextPage, true);
    }

    
    return (
        <>
            {logs.length === 0 && !loading ? (
                <div className="empty_logs_message">
                    {emptyMessage}
                </div>
            ) : (
                <>
                    <div className="events-list">
                        {logs.map((log: any, index: number) => (
                            <div key={index} className="event-item">
                                {/* Si tiene description (nuevo formato), usar ese */}
                                {log.description ? (
                                    <>
                                        <span className="text-o-100" dangerouslySetInnerHTML={{ __html: log.description }}></span>
                                        {log.description_2 && <span className="text-o-60" dangerouslySetInnerHTML={{ __html: log.description_2 }}></span>}
                                        <span className="text-o-30">{log.date || log.event_date}</span>
                                        {log.ip_address && log.ip_address !== 'webhook' && (
                                            <span className="text-o-30">{log.ip_address}</span>
                                        )}
                                    </>
                                ) : (
                                    /* Si no tiene description, usar formato antiguo con log */
                                    <>
                                        <div className="log_text">{log.log}</div>
                                        <div className="log_date">{log.date}</div>
                                        <div className="log_ip">IP: {log.ip_address}</div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>

                    {currentPage < pagination.total_pages && (
                        <div className="loadmore_container">
                            <a 
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    loadMoreLogs();
                                }}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    textDecoration: 'none',
                                    color: '#424242',
                                    cursor: loading ? 'default' : 'pointer',
                                    opacity: loading ? 0.6 : 1,
                                    pointerEvents: loading ? 'none' : 'auto'
                                }}
                            >
                                <PiCaretDown size={16} />
                                {loading ? 'Loading...' : 'Load More'}
                            </a>
                        </div>
                    )}
                </>
            )}
        </>
    )
}
